var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.classnames,attrs:{"id":_vm.uniqueId,"fill":"currentColor","height":_vm.getHeight,"viewBox":"0 0 24 24","width":_vm.getWidth}},[_c('polygon',{attrs:{"id":"Combined-Shape","points":"1.99999999 0 0 1.99999999 9.99999998 12 0 21.9999999 1.99999999 24 12 14 21.9999999 24 24 21.9999999 14 12 24 1.99999999 21.9999999 0 12 9.99999998"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d21dab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/svgs/SvgIconClose.vue
// module id = z7+/
// module chunks = 1